import React, { Component } from 'react';
import { Container, Row, Col, Table, Button, Badge, Alert } from 'react-bootstrap';
import AppSpinner from '../AppSpinner/AppSpinner';
import apiUrl from '../../utils/apiUrl';
import { connect } from 'react-redux';
import { hideFoundationDeletedNotification } from '../../redux/modules/notifications';

const select = state => {
  return {
    token: state.auth.token,
    showNotification: state.notifications.showFoundationDeleted
  };
};

function mapDispatchToProps(dispatch) {
  return {
    hideFoundationDeletedNotification: () => dispatch(hideFoundationDeletedNotification())
  };
}

class ConnectedFoundationsComponent extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      foundationsToValidate: [],
      foundations: []
    };
  }

  async componentDidMount() {

    const { token } = this.props;
    
    const fetchValidatedFoundations = fetch(`${apiUrl}/admin/foundations?all=true&token=${token}`);
    const fetchFoundationsToValidate = fetch(`${apiUrl}/admin/foundations?token=${token}`);

    const respValidatedFoundations = await fetchValidatedFoundations;
    const respFoundationsToValidate = await fetchFoundationsToValidate;

    const dataValidatedFoundations = await respValidatedFoundations.json();
    const dataFoundationsToValidate = await respFoundationsToValidate.json();

    if (dataValidatedFoundations.success && dataFoundationsToValidate.success) {
      this.setState({
        foundationsToValidate: dataFoundationsToValidate.foundations,
        foundations: dataValidatedFoundations.foundations
      });
    }

    this.setState({ isLoading: false });

  }

  render() {

    const { foundations, foundationsToValidate, isLoading } = this.state;
    const { history, showNotification, hideFoundationDeletedNotification } = this.props;

    if (isLoading) return (<AppSpinner />);

    return (
      <div className="table-info-component foundations-component">
        <Container>
          <Row>
            <Col xs={12}>
              {
                showNotification &&
                <Alert variant="info" onClose={hideFoundationDeletedNotification} dismissible>
                  <p>
                    La fundación se eliminó correctamente.
                  </p>
                </Alert>
              }

              <h2 className="header">Fundaciones</h2>
            </Col>

            <Col xs={12}>
              <h4 className="title">Fundaciones por validar</h4>

              {
                !foundationsToValidate.length ? <p>No hay fundaciones por validar.</p> :
              
                <Table striped bordered hover size="sm">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Nombre</th>
                      <th>Correo</th>
                      <th>Teléfono</th>
                      <th>Tipo de validación</th>
                      <th>Editar</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      foundationsToValidate.map((foundation, index) =>
                        <tr key={foundation._id}>
                          <td>{index + 1}</td>
                          <td>{foundation.name}</td>
                          <td>{foundation.email}</td>
                          <td>{foundation.phone}</td>
                          <td>
                            {
                              foundation.validation === '1' &&
                              <span style={{margin: '0 2px'}}>
                                <Badge variant="primary">Validar perfil</Badge>
                              </span>
                            }
                            {
                              foundation.bankInfoToValidate &&
                              <span style={{margin: '0 2px'}}>
                                <Badge variant="warning">Información bancaria</Badge>
                              </span>
                            }
                            {
                              foundation.certificatesInfoToValidate &&
                              <span style={{margin: '0 2px'}}>
                                <Badge variant="info">Información certificados</Badge>
                              </span>
                            }
                          </td>
                          <td>
                            <Button
                              variant="info"
                              size="sm"
                              onClick={() => {
                                history.push(`/fundaciones/${foundation._id}`);
                              }}
                            >
                              Editar
                            </Button>
                          </td>
                        </tr>
                      )
                    }
                  </tbody>
                </Table>
              }
              <hr />
            </Col>

            <Col xs={12}>
              <h4 className="title">Fundaciones validadas</h4>

              <Table striped bordered hover size="sm">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Nombre</th>
                    <th>Correo</th>
                    <th>Teléfono</th>
                    <th>Estado</th>
                    <th>Editar</th>
                    <th>Movimientos</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    foundations.map((foundation, index) =>
                      <tr key={foundation._id}>
                        <td>{index + 1}</td>
                        <td>{foundation.name}</td>
                        <td>{foundation.email}</td>
                        <td>{foundation.phone}</td>
                        <td>
                          {
                            foundation.validation === '2' ? <Badge variant="success">Validada</Badge> :
                            foundation.validationDenied ? <Badge variant="danger">Rechazada</Badge> :
                            <Badge variant="secondary">Perfil incompleto</Badge>
                          }
                          
                        </td>
                        <td>
                          <Button
                            variant="info"
                            size="sm"
                            onClick={() => {
                              history.push(`/fundaciones/${foundation._id}`);
                            }}
                          >
                            Editar
                          </Button>
                        </td>
                        <td>
                          <Button
                            variant="info"
                            size="sm"
                            onClick={() => {
                              history.push(`/extractos_fundaciones/${foundation._id}`);
                            }}
                          >
                            Ver
                          </Button>
                        </td>
                      </tr>
                    )
                  }
                </tbody>
              </Table>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

const FoundationsComponent = connect(select, mapDispatchToProps)(ConnectedFoundationsComponent);

export default FoundationsComponent;
